interface Props {
    texto: string;
    onClick: () => void;
}

export const CtaCierreCotizador = ({ texto, onClick }: Props) => {
    return (
        <div className="py-5 bg-f4">
            <div className="container text-center">
                <p className="fs-20 fs-lg-24 fw-bold text-black mb-25">{texto}</p>
                <button type="button" className="btn btn-primary btn-lg" onClick={onClick}>
                    Cotizar gratis
                </button>
            </div>
        </div>
    );
};
